import React from 'react';
import { FlightSummary } from 'Components/widgets/transport-details/flight-summary/FlightSummary';
import { getTransportIcon } from 'Components/widgets/transport-details/transportUtils';
import { capitalizeName } from 'Utils/label/labelUtils';
type Props = {
  i18n: any;
  transports: Transport;
};

function TransportDetails({ i18n, transports: { inbound, outbound } }: Props) {
  function renderFlightSummary(way: 'INBOUND' | 'OUTBOUND') {
    const transportIcon = getTransportIcon(inbound, outbound);
    const flight = way === 'INBOUND' ? inbound : outbound;
    const start = flight.travelSections[0].departure;
    const end = flight.travelSections[flight.travelSections.length - 1].arrival;
    return (
      <FlightSummary
        way={way}
        transportIcon={transportIcon}
        departureFullName={capitalizeName(start.label)}
        arrivalFullName={capitalizeName(end.label)}
        i18n={i18n}
        date={start.date}
      />
    );
  }

  return (
    <div>
      {renderFlightSummary('INBOUND')}
      {renderFlightSummary('OUTBOUND')}
    </div>
  );
}

export default TransportDetails;
